import { EnumRole, ITranslation } from '@types';

export enum EnumPermissionItems {
    localities = 'LOCALITIES',
    directions = 'DIRECTIONS',
    stops = 'STOPS',
    options = 'OPTIONS',
    settings = 'SETTINGS',
    drivers = 'DRIVERS',
    routes = 'ROUTES',
    permissions = 'PERMISSIONS',
    admins = 'ADMINS',
    passengers = 'PASSENGERS',
    blacks = 'BLACKS',
    trips = 'TRIPS',
    bookings = 'BOOKINGS',
}

export interface IPermissionsInitialState {
    permissionsList: IPermissionsList;
}

export interface IPermissionsList {
    total: number;
    permissions: IPermission[];
}

export interface IPermission {
    uuid: string;
    creation: Date;
    modification: Date;
    item: EnumPermissionItems;
    role: EnumRole;
    view: boolean;
    edit: boolean;
    translations: ITranslation;
}

export interface IEditPermissionBody {
    item: EnumPermissionItems;
    role: EnumRole;
    view: boolean;
    edit: boolean;
}
